import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Employees.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from '../../api/apiClient';
import { token, domain } from '../Security';

import { base64ToFile } from "../../utils/fileUtils";
// icons
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { PersonalTab } from './ViewEmployeeFld/tabs/PersonalTab';
import { AddressTab } from './ViewEmployeeFld/tabs/AddressTab';
import { InformationTab } from './ViewEmployeeFld/tabs/InformationTab';
import { AccountsTab } from './ViewEmployeeFld/tabs/AccountsTabFld/AccountsTab';
import { EducationsTab } from './ViewEmployeeFld/tabs/EducationsTab';
import { TrainingsAndSeminarsTab } from './ViewEmployeeFld/tabs/TrainingsAndSeminarsTab';
import { DependentsTab } from './ViewEmployeeFld/tabs/DependentsTab';
import { EmergencyTab } from './ViewEmployeeFld/tabs/EmergencyTab';
import { FamilyTab } from './ViewEmployeeFld/tabs/FamilyTab';
import { BenefitsTab } from './ViewEmployeeFld/tabs/BenefitsTab';
import { RequirementsTab } from './ViewEmployeeFld/tabs/RequirementsTab';
import { GenerateQRIdTab } from './ViewEmployeeFld/tabs/GenerateQR';
import { LoadingSpinner } from '../../common/Loading';
import { Next, Previous } from './ViewEmployeeFld/utils/page';

const showUpdate = false;

function EmployeeInformation({ user }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedEducationTab, setSelectedEducationTab] = useState(0);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(true);

  //EmployeeData
  const [employeeData, setEmployeeData] = useState(true);

  //Personal
  const [id, setId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [extensionName, setExtensionName] = useState("");
  const [nickName, setNickName] = useState("");
  const [age, setAge] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [bloodType, setBloodType] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [religion, setReligion] = useState("");
  const [gender, setGender] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [companyId, setCompanyTypeId] = useState("");
  const [signature, setSignature] = useState([]);
  const [license, setLicense] = useState("");
  //Address
  const [blkLot, setBlkLot] = useState("");
  const [street, setStreet] = useState("");
  const [barangay, setBarangay] = useState("");
  const [city, setCity] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [yearsOfStay, setYearsOfStay] = useState("");
  //Information
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [contractFrom, setContractFrom] = useState("");
  const [contractTo, setContractTo] = useState("");
  const [locationId, setLocationId] = useState("");
  const [dateEmployed, setDateEmployed] = useState("");
  const [dateRegular, setDateRegular] = useState("");
  const [dateProbationary, setDateProbationary] = useState("");
  const [dateProjectBase, setDateProjectBase] = useState("");
  const [dateContractual, setDateContractual] = useState("");
  const [employmentId, setEmploymentId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");
  const [positionId, setPositionId] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [maintenanceSalaryCombinationV2Id, setmaintenanceSalaryCombinationV2Id] = useState("");
  const [sickLeave, setSickLeave] = useState("");
  const [vacationLeave, setVacationLeave] = useState("");
  const [serviceIncentiveLeave, setServiceIncentiveLeave] = useState("");
  const [soloParentLeave, setSoloParentLeave] = useState("");
  const [sickRemaining, setSickRemaining] = useState("");
  const [vacationRemaining, setVacationRemaining] = useState("");
  const [serviceIncentiveRemaining, setServiceIncentiveRemaining] = useState("");
  const [soloParentRemaining, setSoloParentRemaining] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("");

  const [jobTitleId, setJobTitleId] = useState("");
  const [employeeGroup1Id, setEmployeeGroup1Id] = useState("");
  const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
  const [plantilyaId, setPlantilyaId] = useState("");
  const [costCenterId, setCostCenterId] = useState("");
  const [clientId, setClientId] = useState("");
  const [employeeTypeId, setEmployeeTypeId] = useState("");
  const [vesselId, setVesselId] = useState("");
  const [destinationId, setDestinationId] = useState("");
  //Accounts
  // Gov
  const [sss, setsss] = useState("");
  const [tin, setTin] = useState("");
  const [philhealth, setPhilhealth] = useState("");
  const [pagibig, setPagibig] = useState("");

  // Passport & Seaman
  const [passport, setPassport] = useState(""); // This is the Passport Number
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [seamansBookNumber, setSeamansBookNumber] = useState("");
  const [seamansBookIssueDate, setSeamansBookIssueDate] = useState("");
  const [seamansBookExpiryDate, setSeamansBookExpiryDate] = useState("");

  // License Information
  const [licenseCode, setLicenseCode] = useState("");
  const [licenseDescription, setLicenseDescription] = useState("");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [licenseQualified, setLicenseQualified] = useState(false);
  const [licenseExpirationDate, setLicenseExpirationDate] = useState("");

  // Bank Accounts
  const [employeeBankAccounts, setEmployeeBankAccounts] = useState([]);
  //Education and Trainings
  const [employeeEducationAttainments, setEmployeeEducationAttainments] = useState([]);
  const [employeeTrainingSeminars, setEmployeeTrainingSeminars] = useState([]);
  //Dependents
  const [employeeDependents, setEmployeeDependents] = useState([]);
  //Emegency
  const [employeeEmergencyContacts, setEmployeeEmergencyContacts] = useState([]);
  //Family
  const [employeeFamilyData, setEmployeeFamilyData] = useState([]);
  //Restdays
  const [employeeRestDays, setEmployeeRestDays] = useState([]);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end
  const fetchDataEmployeeInfo = useCallback(async () => {
    const apiUrl = domain + `/api/Employee/${user.employeePersonalInformationId}`;
    setLoading(true);

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      console.log({ fetchDataEmployeeInfo: response.data })

      return response.data;

    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
      return []
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [user]);
  const fetchDataEmployeeTrainingById = useCallback(async (id) => {
    const apiUrl = domain + "/api/Employee/trainings-seminar/id/";
    try {
      const response = await axios.get(apiUrl + `${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;

    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    const fetchEmployeeInfo = async () => {
      const viewedData = await fetchDataEmployeeInfo();

      setId(viewedData.id);
      setEmployeeId(viewedData.employeeId);
      setLastName(viewedData.lastName);
      setFirstName(viewedData.firstName);
      setMiddleName(viewedData.middleName);
      setExtensionName(viewedData.extensionName);
      setNickName(viewedData.nickName);
      setAge(viewedData.age);
      setDateOfBirth(viewedData.dateOfBirth);
      setPlaceOfBirth(viewedData.placeOfBirth);
      setCivilStatus(viewedData.civilStatus);
      setBloodType(viewedData.bloodType);
      setHeight(viewedData.height);
      setWeight(viewedData.weight);
      setCitizenship(viewedData.citizenship);
      setReligion(viewedData.religion);
      setGender(viewedData.gender);
      setMobileNumber(viewedData.mobileNumber);
      setEmailAddress(viewedData.emailAddress);
      setDeviceNumber(viewedData.deviceNumber);
      setLicense(viewedData.license);
      setBlkLot(viewedData.blkLot);
      setStreet(viewedData.street);
      setBarangay(viewedData.barangay);
      setCity(viewedData.city);
      setMunicipality(viewedData.municipality);
      setPostalCode(viewedData.postalCode);
      setYearsOfStay(viewedData.yearsOfStay);

      if (viewedData.photo) {
        const binaryData = atob(viewedData.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setSelectedFile(file);
      }

      let filesToBeSet = [];
      if (viewedData.signature) {
        const binaryData = atob(viewedData.signature);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setSignature(filesToBeSet);

      // Setting the files for Trainings and Seminar
      const updatedTrainings = await Promise.all(
        viewedData.employeeTrainingSeminars.map(async (training) => {
          try {
            const trainingDetail = await fetchDataEmployeeTrainingById(training.id);

            // Normalize: always get a single object
            const detail = Array.isArray(trainingDetail)
              ? trainingDetail.find(t => t.id === training.id)
              : trainingDetail;
            return {
              ...training,
              file: detail.file ? base64ToFile(detail.file, detail.fileName) : null,
            };
          } catch (error) {
            console.error("Error fetching training:", error);
            return { ...training, file: null };
          }
        })
      );

      if (viewedData.employeeInformation) {
        setEffectiveFrom(viewedData.employeeInformation.effectiveFrom);
        setContractFrom(viewedData.employeeInformation.contractFrom);
        setContractTo(viewedData.employeeInformation.contractTo);
        setCompanyTypeId(viewedData.employeeInformation.companyId);
        setLocationId(viewedData.employeeInformation.locationId);
        setDateEmployed(viewedData.employeeInformation.dateEmployed);
        setDateRegular(viewedData.employeeInformation.dateRegular);
        setDateProbationary(viewedData.employeeInformation.dateProbationary);
        setDateProjectBase(viewedData.employeeInformation.dateProjectBase);
        setDateContractual(viewedData.employeeInformation.dateContractual);
        setEmploymentId(viewedData.employeeInformation.employmentId);
        setDepartmentId(viewedData.employeeInformation.departmentId);
        setSectionId(viewedData.employeeInformation.sectionId);
        setClassificationId(viewedData.employeeInformation.classificationId);
        setPayTypeId(viewedData.employeeInformation.payTypeId);
        setShiftScheduleId(viewedData.employeeInformation.shiftScheduleId);
        setPositionId(viewedData.employeeInformation.positionId);
        setSalaryType(viewedData.employeeInformation.salaryType);
        setmaintenanceSalaryCombinationV2Id(viewedData.employeeInformation.maintenanceSalaryCombinationV2Id);
        setJobTitleId(viewedData.employeeInformation.jobTitleId);
        setEmployeeGroup1Id(viewedData.employeeInformation.employeeGroup1Id);
        setEmployeeGroup2Id(viewedData.employeeInformation.employeeGroup2Id);
        setPlantilyaId(viewedData.employeeInformation.plantilyaId);
        setCostCenterId(viewedData.employeeInformation.costCenterId);
        setClientId(viewedData.employeeInformation.clientId);
        setEmployeeTypeId(viewedData.employeeInformation.employeeTypeId);
        setVesselId(viewedData.employeeInformation.vesselId);
        setDestinationId(viewedData.employeeInformation.destinationId);
      } else {
        setEffectiveFrom("");
        setContractFrom("");
        setContractTo("");
        setCompanyTypeId("");
        setLocationId("");
        setDateEmployed("");
        setDateRegular("");
        setDateProbationary("");
        setDateProjectBase("");
        setDateContractual("");
        setEmploymentId("");
        setDepartmentId("");
        setSectionId("");
        setClassificationId("");
        setPayTypeId("");
        setShiftScheduleId("");
        setPositionId("");
        setJobTitleId("");
        setEmployeeGroup1Id("");
        setEmployeeGroup2Id("");
        setPlantilyaId("");
        setCostCenterId("");
        setClientId("");
        setEmployeeTypeId("");
        setVesselId("");
        setDestinationId("");
      }

      if (viewedData.employeeLeave) {
        setSickLeave(viewedData.employeeLeave.totalSick ? viewedData.employeeLeave.totalSick : 0);
        setVacationLeave(viewedData.employeeLeave.totalVacation ? viewedData.employeeLeave.totalVacation : 0);
        setServiceIncentiveLeave(viewedData.employeeLeave.totalServiceIncentive ? viewedData.employeeLeave.totalServiceIncentive : 0);
        setSoloParentLeave(viewedData.employeeLeave.totalSoloParent ? viewedData.employeeLeave.totalSoloParent : 0);

        setSickRemaining(viewedData.employeeLeave.sickRemaining ? viewedData.employeeLeave.sickRemaining : 0);
        setVacationRemaining(viewedData.employeeLeave.vacationRemaining ? viewedData.employeeLeave.vacationRemaining : 0);
        setServiceIncentiveRemaining(viewedData.employeeLeave.serviceIncentiveRemaining ? viewedData.employeeLeave.serviceIncentiveRemaining : 0);
        setSoloParentRemaining(viewedData.employeeLeave.soloParentRemaining ? viewedData.employeeLeave.soloParentRemaining : 0);
      } else {
        setSickLeave(0);
        setVacationLeave(0);
        setServiceIncentiveLeave(0);
        setSoloParentLeave(0);

        setSickRemaining(0);
        setVacationRemaining(0);
        setServiceIncentiveRemaining(0);
        setSoloParentRemaining(0);
      }

      if (viewedData.employeeStatuses) {
        setEmployeeStatus(viewedData.employeeStatuses.status ? viewedData.employeeStatuses.status : "");
      } else {
        setEmployeeStatus("");
      }

      // Accounts : Government
      setsss(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.sss : "");
      setTin(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.tin : "");
      setPhilhealth(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.philhealth : "");
      setPagibig(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.pagibig : "");
      // Note: We removed setPassport here because it is now in employeePassportDetail

      // Passport
      setPassport(viewedData.employeePassportDetail?.passportNumber ?? "");
      setPassportIssueDate(viewedData.employeePassportDetail?.passportIssueDate
        ? viewedData.employeePassportDetail.passportIssueDate.split("T")[0] : "");
      setPassportExpiryDate(viewedData.employeePassportDetail?.passportExpiryDate
        ? viewedData.employeePassportDetail.passportExpiryDate.split("T")[0] : "");

      // Seaman Book
      setSeamansBookNumber(viewedData.employeeSeamanBookDetail?.seamanBookNumber ?? "");
      setSeamansBookIssueDate(viewedData.employeeSeamanBookDetail?.bookIssueDate
        ? viewedData.employeeSeamanBookDetail.bookIssueDate.split("T")[0] : "");
      setSeamansBookExpiryDate(viewedData.employeeSeamanBookDetail?.bookExpiryDate
        ? viewedData.employeeSeamanBookDetail.bookExpiryDate.split("T")[0] : "");

      // License Information
      if (viewedData.employeeLicenseInformation) {
        setLicenseCode(viewedData.employeeLicenseInformation.licenseCode ?? "");
        setLicenseDescription(viewedData.employeeLicenseInformation.description ?? "");
        setLicenseNumber(viewedData.employeeLicenseInformation.licenseNumber ?? "");
        setLicenseQualified(viewedData.employeeLicenseInformation.isQualified ?? false);
        setLicenseExpirationDate(viewedData.employeeLicenseInformation.expirationDate
          ? viewedData.employeeLicenseInformation.expirationDate.split("T")[0] : "");
      } else {
        setLicenseCode("");
        setLicenseDescription("");
        setLicenseNumber("");
        setLicenseQualified(false);
        setLicenseExpirationDate("");
      }

      // Bank Accounts
      setEmployeeBankAccounts(viewedData.employeeBankAccounts || []);

      setEmployeeEducationAttainments(viewedData.employeeEducationAttainments);
      setEmployeeTrainingSeminars(updatedTrainings); // go top to see the convertion
      // setEmployeeTrainingSeminars(viewedData.employeeEducationAttainments); // go top to see the convertion
      setEmployeeDependents(viewedData.employeeDependents);
      setEmployeeEmergencyContacts(viewedData.employeeEmergencyContacts);
      setEmployeeFamilyData(viewedData.employeeFamilyData);
      setEmployeeRestDays(viewedData.employeeRestDays);

      // In your fetchEmployeeInfo function, after setting all states:
      const employeeDataCust = {
        id: viewedData.id,
        employeeId: viewedData.employeeId,
      };

      setEmployeeData(employeeDataCust);
    };

    if (isUpdate) {
      fetchEmployeeInfo();
      setIsUpdate(false);
    }
  }, [fetchDataEmployeeInfo, user, isUpdate]);

  const apiUrl = domain + "/api/Employee";

  const handleUpdate = async (event) => {
    event.preventDefault();

    setLoading(true);

    const now = new Date();

    const toBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    let base64String = "";
    let photoToBeSave = "";

    if (selectedFile) {
      base64String = await toBase64(selectedFile);
      photoToBeSave = base64String.split(',')[1];
    }

    let base64StringSignature = "";
    let photoToBeSaveSignature = "";

    if (signature.length > 0) {
      base64StringSignature = await toBase64(signature[0]);
      photoToBeSaveSignature = base64StringSignature.split(',')[1];
    }

    const data = {
      id: id,
      employeeId: employeeId,
      lastName: lastName,
      firstName: firstName,
      middleName: middleName,
      extensionName: extensionName,
      fullName: lastName + ", " + firstName,
      nickName: nickName,
      age: age ? age : 0,
      dateOfBirth: dateOfBirth ? dateOfBirth : null,
      placeOfBirth: placeOfBirth,
      civilStatus: civilStatus,
      bloodType: bloodType,
      height: height,
      weight: weight,
      citizenship: citizenship,
      religion: religion,
      gender: gender,
      mobileNumber: mobileNumber,
      emailAddress: emailAddress,
      blkLot: blkLot,
      street: street,
      barangay: barangay,
      city: city,
      municipality: municipality,
      postalCode: postalCode,
      yearsOfStay: yearsOfStay ? yearsOfStay : 0,
      photo: selectedFile ? photoToBeSave : null,
      signature: signature ? photoToBeSaveSignature : null,
      deviceNumber: deviceNumber,
      license: license,
      employeeInformation: {
        employeePersonalInformationId: id,
        effectiveFrom: effectiveFrom ? effectiveFrom : null,
        contractFrom: contractFrom ? contractFrom : null,
        contractTo: contractTo ? contractTo : null,
        locationId: locationId ? locationId : null,
        dateEmployed: dateEmployed ? dateEmployed : null,
        dateRegular: dateRegular ? dateRegular : null,
        dateProbationary: dateProbationary ? dateProbationary : null,
        dateProjectBase: dateProjectBase ? dateProjectBase : null,
        dateContractual: dateContractual ? dateContractual : null,
        employmentId: employmentId ? employmentId : null,
        departmentId: departmentId ? departmentId : null,
        sectionId: sectionId ? sectionId : null,
        classificationId: classificationId ? classificationId : null,
        payTypeId: payTypeId ? payTypeId : null,
        shiftScheduleId: shiftScheduleId ? shiftScheduleId : null,
        positionId: positionId ? positionId : null,
        companyId: companyId ? companyId : null,
        salaryType: salaryType,
        maintenanceSalaryCombinationV2Id: maintenanceSalaryCombinationV2Id,
        jobTitleId: jobTitleId ? jobTitleId : null,
        employeeGroup1Id: employeeGroup1Id ? employeeGroup1Id : null,
        employeeGroup2Id: employeeGroup2Id ? employeeGroup2Id : null,
        plantilyaId: plantilyaId ? plantilyaId : null,
        costCenterId: costCenterId ? costCenterId : null,
        clientId: clientId ? clientId : null,
        employeeTypeId: employeeTypeId ? employeeTypeId : null,
        vesselId: vesselId ? vesselId : null,
        destinationId: destinationId ? destinationId : null,
        createdDate: now,
        createdBy: 0,
      },
      employeeReportTo: {
        employeePersonalInformationId: id,
        reportToId: null
      },
      employeeAccountInformation: {
        employeePersonalInformationId: id,
        sss: sss,
        tin: tin,
        philhealth: philhealth,
        pagibig: pagibig,
      },
      employeePassportDetail: {
        employeePersonalInformationId: id,
        passportNumber: passport,
        passportIssueDate: passportIssueDate ? passportIssueDate : null,
        passportExpiryDate: passportExpiryDate ? passportExpiryDate : null,
      },
      employeeSeamanBookDetail: {
        employeePersonalInformationId: id,
        seamanBookNumber: seamansBookNumber,
        bookIssueDate: seamansBookIssueDate ? seamansBookIssueDate : null,
        bookExpiryDate: seamansBookExpiryDate ? seamansBookExpiryDate : null,
      },
      employeeLicenseInformation: {
        employeePersonalInformationId: id,
        licenseCode: licenseCode,
        licenseNumber: licenseNumber,
        description: licenseDescription,
        expirationDate: licenseExpirationDate ? licenseExpirationDate : null,
        isQualified: licenseQualified,
      },
      employeeBankAccounts: employeeBankAccounts,
      employeeEducationAttainments: employeeEducationAttainments,
      employeeDependents: employeeDependents,
      employeeFamilyData: employeeFamilyData,
      employeeEmergencyContacts: employeeEmergencyContacts,
      employeeLeave: {
        employeePersonalInformationId: id,
        totalVacation: vacationLeave,
        totalSick: sickLeave,
        totalServiceIncentive: serviceIncentiveLeave,
        totalSoloParent: soloParentLeave,
        sickRemaining: sickRemaining,
        vacationRemaining: vacationRemaining,
        serviceIncentiveRemaining: serviceIncentiveRemaining,
        soloParentRemaining: soloParentRemaining,
      },
      employeeStatuses: {
        employeePersonalInformationId: id,
        status: employeeStatus,
      },
      employeeRestDays: employeeRestDays
    };

    try {

      await axios.put(apiUrl + `/${id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setShowRequestMessage(true);
      setIsSuccess(true);
      console.log('Data updated successfully');

      setIsUpdate(true);
      setEmployeeId(data.employeeId);
      setLastName(data.lastName);
      setFirstName(data.firstName);
      setMiddleName(data.middleName);
      setExtensionName(data.extensionName);
      setNickName(data.nickName);
      setAge(data.age);
      setDateOfBirth(data.dateOfBirth);
      setPlaceOfBirth(data.placeOfBirth);
      setCivilStatus(data.civilStatus);
      setBloodType(data.bloodType);
      setHeight(data.height);
      setWeight(data.weight);
      setCitizenship(data.citizenship);
      setReligion(data.religion);
      setGender(data.gender);
      setMobileNumber(data.mobileNumber);
      setEmailAddress(data.emailAddress);
      setDeviceNumber(data.deviceNumber);
      setLicense(data.license);
      setCompanyTypeId(data.employeeInformation.companyId);
      setBlkLot(data.blkLot);
      setStreet(data.street);
      setBarangay(data.barangay);
      setCity(data.city);
      setMunicipality(data.municipality);
      setPostalCode(data.postalCode);
      setYearsOfStay(data.yearsOfStay);

      if (data.photo) {
        const binaryData = atob(data.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setSelectedFile(file);
      }

      let filesToBeSet = [];
      if (data.signature) {
        const binaryData = atob(data.signature);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setSignature(filesToBeSet);
      setEffectiveFrom(data.employeeInformation.effectiveFrom);
      setContractFrom(data.employeeInformation.contractFrom);
      setContractTo(data.employeeInformation.contractTo);
      setLocationId(data.employeeInformation.locationId);
      setDateEmployed(data.employeeInformation.dateEmployed);
      setDateRegular(data.employeeInformation.dateRegular);
      setDateProbationary(data.employeeInformation.dateProbationary);
      setDateProjectBase(data.employeeInformation.dateProjectBase);
      setDateContractual(data.employeeInformation.dateContractual);
      setEmploymentId(data.employeeInformation.employmentId);
      setDepartmentId(data.employeeInformation.departmentId);
      setSectionId(data.employeeInformation.sectionId);
      setClassificationId(data.employeeInformation.classificationId);
      setPayTypeId(data.employeeInformation.payTypeId);
      setShiftScheduleId(data.employeeInformation.shiftScheduleId);
      setPositionId(data.employeeInformation.positionId);
      setSalaryType(data.employeeInformation.salaryType);
      setmaintenanceSalaryCombinationV2Id(data.employeeInformation.maintenanceSalaryCombinationV2Id);
      setJobTitleId(data.employeeInformation.jobTitleId);
      setEmployeeGroup1Id(data.employeeInformation.employeeGroup1Id);
      setEmployeeGroup2Id(data.employeeInformation.employeeGroup2Id);
      setPlantilyaId(data.employeeInformation.plantilyaId);
      setCostCenterId(data.employeeInformation.costCenterId);
      setClientId(data.employeeInformation.clientId);
      setEmployeeTypeId(data.employeeInformation.employeeTypeId);
      setVesselId(data.employeeInformation.vesselId);
      setDestinationId(data.employeeInformation.destinationId);
      /* setVacationLeave(data.);
      setSickLeave("");
      setServiceIncentiveLeave("");
      setEmployeeStatus(""); */
      setsss(data.employeeAccountInformation.sss);
      setTin(data.employeeAccountInformation.tin);
      setPassport(data.employeeAccountInformation.passport);
      setPhilhealth(data.employeeAccountInformation.philhealth);
      setPagibig(data.employeeAccountInformation.pagibig);

      setVacationLeave((data.employeeLeave && data.employeeLeave.totalVacation) ? data.employeeLeave.totalVacation : 0)
      setSickLeave((data.employeeLeave && data.employeeLeave.totalSick) ? data.employeeLeave.totalSick : 0)
      setServiceIncentiveLeave((data.employeeLeave && data.employeeLeave.totalServiceIncentive) ? data.employeeLeave.totalServiceIncentive : 0)
      setSoloParentLeave((data.employeeLeave && data.employeeLeave.totalSoloParent) ? data.employeeLeave.totalSoloParent : 0)
      setVacationRemaining((data.employeeLeave && data.employeeLeave.vacationRemaining) ? data.employeeLeave.vacationRemaining : 0)
      setSickRemaining((data.employeeLeave && data.employeeLeave.sickRemaining) ? data.employeeLeave.sickRemaining : 0)
      setServiceIncentiveRemaining((data.employeeLeave && data.employeeLeave.setVacationRemaining) ? data.employeeLeave.setVacationRemaining : 0)
      setSoloParentRemaining((data.employeeLeave && data.employeeLeave.soloParentRemaining) ? data.employeeLeave.soloParentRemaining : 0)
      setEmployeeStatus((data.employeeStatuses && data.employeeStatuses.status) ? data.employeeStatuses.status : "")

      setEmployeeEducationAttainments(data.employeeEducationAttainments);
      setEmployeeTrainingSeminars(data.employeeTrainingSeminars);
      setEmployeeDependents(data.employeeDependents);
      setEmployeeEmergencyContacts(data.employeeEmergencyContacts);
      setEmployeeFamilyData(data.employeeFamilyData);
    } catch (error) {
      setLoading(false);
      console.error('There was a problem updating data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTab > 0) {
      setIsFirstPage(false);
    } else {
      setIsFirstPage(true);
    }

    if (selectedTab === 7) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [selectedTab]); // This useEffect will run whenever selectedTab changes

  const setButtonId = (name) => {
    if (name === "previous-button") {
      if (isFirstPage) {
        return "previous-button"
      } else {
        return "active-previous-button"
      }
    } else if (name === "next-button") {
      if (isLastPage) {
        return "next-button"
      } else {
        return "active-next-button"
      }
    }
  }

  return (
    <div>
      <div className="MainBody row">
        <div className="LeftSpace"></div>
        <div className="BodySpace">
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Personnel >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Employee Information"}</span>
              </div>
              <div className="employeesTab-title">
                <h3 style={{ textAlign: "center", fontSize: "30px" }}>Employee Information</h3>
                <label style={{
                  color: "#808080b5",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                > Comprehensive details and records.
                </label>
              </div>

            </div>
            <div className="employeesTab-body">
              <div className='employeesTab-tab'>
                <div style={{ border: "1px solid #00000026", borderRadius: "5px" }}>
                  <Tabs id="employees-tabs-element" selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
                    <TabList>
                      <Tab><b>PERSONAL</b></Tab>
                      <Tab><b>ADDRESS</b></Tab>
                      <Tab><b>INFORMATION</b></Tab>
                      <Tab><b>ACCOUNTS</b></Tab>
                      <Tab><b>EDUCATIONS</b></Tab>
                      <Tab><b>DEPENDENTS</b></Tab>
                      <Tab><b>EMERGENCY</b></Tab>
                      <Tab><b>FAMILY</b></Tab>
                      <Tab><b>BENEFITS</b></Tab>
                      <Tab><b>REQUIREMENTS</b></Tab>
                      <Tab><b>GENERATE QR</b></Tab>
                    </TabList>
                    <div className="employeesTab-tabPanel" style={{ height: "auto" }}>
                      <TabPanel>
                        <PersonalTab employeeId={employeeId}
                          selectedFile={selectedFile}
                          setSelectedFile={setSelectedFile}
                          lastName={lastName}
                          firstName={firstName}
                          middleName={middleName}
                          extensionName={extensionName}
                          nickName={nickName}
                          age={age}
                          dateOfBirth={dateOfBirth}
                          placeOfBirth={placeOfBirth}
                          civilStatus={civilStatus}
                          bloodType={bloodType}
                          height={height}
                          weight={weight}
                          citizenship={citizenship}
                          religion={religion}
                          gender={gender}
                          mobileNumber={mobileNumber}
                          emailAddress={emailAddress}
                          deviceNumber={deviceNumber}
                          companyId={companyId}
                          license={license}
                          setEmployeeId={setEmployeeId}
                          setLastName={setLastName}
                          setFirstName={setFirstName}
                          setMiddleName={setMiddleName}
                          setExtensionName={setExtensionName}
                          setNickName={setNickName}
                          setAge={setAge}
                          setDateOfBirth={setDateOfBirth}
                          setPlaceOfBirth={setPlaceOfBirth}
                          setCivilStatus={setCivilStatus}
                          setBloodType={setBloodType}
                          setHeight={setHeight}
                          setWeight={setWeight}
                          setCitizenship={setCitizenship}
                          setReligion={setReligion}
                          setGender={setGender}
                          setMobileNumber={setMobileNumber}
                          setEmailAddress={setEmailAddress}
                          setDeviceNumber={setDeviceNumber}
                          setCompanyTypeId={setCompanyTypeId}
                          setLicense={setLicense}

                          signature={signature} setSignature={setSignature}
                        />
                      </TabPanel>

                      <TabPanel>
                        <AddressTab
                          blkLot={blkLot}
                          street={street}
                          barangay={barangay}
                          city={city}
                          municipality={municipality}
                          postalCode={postalCode}
                          yearsOfStay={yearsOfStay}
                          setBlkLot={setBlkLot}
                          setStreet={setStreet}
                          setBarangay={setBarangay}
                          setCity={setCity}
                          setMunicipality={setMunicipality}
                          setPostalCode={setPostalCode}
                          setYearsOfStay={setYearsOfStay}
                        />
                      </TabPanel>

                      <TabPanel>
                        <InformationTab
                          effectiveFrom={effectiveFrom}
                          contractFrom={contractFrom}
                          contractTo={contractTo}
                          locationId={locationId}
                          dateEmployed={dateEmployed}
                          dateRegular={dateRegular}
                          dateProbationary={dateProbationary}
                          dateProjectBase={dateProjectBase}
                          dateContractual={dateContractual}
                          employmentId={employmentId}
                          departmentId={departmentId}
                          sectionId={sectionId}
                          classificationId={classificationId}
                          payTypeId={payTypeId}
                          shiftScheduleId={shiftScheduleId}
                          positionId={positionId}
                          salaryType={salaryType}
                          maintenanceSalaryCombinationV2Id={maintenanceSalaryCombinationV2Id}
                          setEffectiveFrom={setEffectiveFrom}
                          setContractFrom={setContractFrom}
                          setContractTo={setContractTo}
                          setLocationId={setLocationId}
                          setDateEmployed={setDateEmployed}
                          setDateRegular={setDateRegular}
                          setDateProbationary={setDateProbationary}
                          setDateProjectBase={setDateProjectBase}
                          setDateContractual={setDateContractual}
                          setEmploymentId={setEmploymentId}
                          setDepartmentId={setDepartmentId}
                          setSectionId={setSectionId}
                          setClassificationId={setClassificationId}
                          setPayTypeId={setPayTypeId}
                          setShiftScheduleId={setShiftScheduleId}
                          setPositionId={setPositionId}
                          setSalaryType={setSalaryType}
                          setmaintenanceSalaryCombinationV2Id={setmaintenanceSalaryCombinationV2Id}
                          sickLeave={sickLeave}
                          setSickLeave={setSickLeave}
                          vacationLeave={vacationLeave}
                          setVacationLeave={setVacationLeave}
                          employeeStatus={employeeStatus}
                          setEmployeeStatus={setEmployeeStatus}
                          serviceIncentiveLeave={serviceIncentiveLeave}
                          setServiceIncentiveLeave={setServiceIncentiveLeave}
                          soloParentLeave={soloParentLeave}
                          setSoloParentLeave={setSoloParentLeave}

                          sickRemaining={sickRemaining}
                          setSickRemaining={setSickRemaining}
                          vacationRemaining={vacationRemaining}
                          setVacationRemaining={setVacationRemaining}
                          serviceIncentiveRemaining={serviceIncentiveRemaining}
                          setServiceIncentiveRemaining={setServiceIncentiveRemaining}
                          soloParentRemaining={soloParentRemaining}
                          setSoloParentRemaining={setSoloParentRemaining}

                          jobTitleId={jobTitleId} setJobTitleId={setJobTitleId}
                          employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id}
                          employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id}
                          plantilyaId={plantilyaId}
                          setPlantilyaId={setPlantilyaId}
                          costCenterId={costCenterId}
                          setCostCenterId={setCostCenterId}
                          clientId={clientId}
                          setClientId={setClientId}
                          employeeTypeId={employeeTypeId} setEmployeeTypeId={setEmployeeTypeId}
                          vesselId={vesselId} setVesselId={setVesselId}
                          destinationId={destinationId} setDestinationId={setDestinationId}

                          employeeRestDays={employeeRestDays} setEmployeeRestDays={setEmployeeRestDays}
                        />
                      </TabPanel>

                      <TabPanel>
                        <AccountsTab
                          // Gov
                          sss={sss}
                          tin={tin}
                          philhealth={philhealth}
                          pagibig={pagibig}
                          setsss={setsss}
                          setTin={setTin}
                          setPhilhealth={setPhilhealth}
                          setPagibig={setPagibig}

                          // Passport
                          passport={passport}
                          setPassport={setPassport}
                          passportIssueDate={passportIssueDate}
                          setPassportIssueDate={setPassportIssueDate}
                          passportExpiryDate={passportExpiryDate}
                          setPassportExpiryDate={setPassportExpiryDate}

                          // Seaman
                          seamansBookNumber={seamansBookNumber}
                          setSeamansBookNumber={setSeamansBookNumber}
                          seamansBookIssueDate={seamansBookIssueDate}
                          setSeamansBookIssueDate={setSeamansBookIssueDate}
                          seamansBookExpiryDate={seamansBookExpiryDate}
                          setSeamansBookExpiryDate={setSeamansBookExpiryDate}

                          // License
                          licenseCode={licenseCode}
                          setLicenseCode={setLicenseCode}
                          licenseDescription={licenseDescription}
                          setLicenseDescription={setLicenseDescription}
                          licenseNumber={licenseNumber}
                          setLicenseNumber={setLicenseNumber}
                          licenseQualified={licenseQualified}
                          setLicenseQualified={setLicenseQualified}
                          licenseExpirationDate={licenseExpirationDate}
                          setLicenseExpirationDate={setLicenseExpirationDate}

                          // Bank
                          employeeBankAccounts={employeeBankAccounts}
                          setEmployeeBankAccounts={setEmployeeBankAccounts}
                        />
                      </TabPanel>

                      <TabPanel>
                        <Tabs id="educations-tabs-element2" selectedIndex={selectedEducationTab} onSelect={index => setSelectedEducationTab(index)}>
                          <TabList>
                            <Tab><b>EDUCATIONS</b></Tab>
                            <Tab><b>TRAININGS & SEMINARS</b></Tab>
                          </TabList>
                          <TabPanel>
                            <EducationsTab employeeId={employeeId}
                              employeeEducationAttainments={employeeEducationAttainments}
                              setEmployeeEducationAttainments={setEmployeeEducationAttainments}
                            />
                          </TabPanel>
                          <TabPanel>
                            <TrainingsAndSeminarsTab employeeId={employeeId}
                              employeeTrainingSeminars={employeeTrainingSeminars}
                              setEmployeeTrainingSeminars={setEmployeeTrainingSeminars}
                            />
                          </TabPanel>
                        </Tabs>
                      </TabPanel>

                      <TabPanel>
                        <DependentsTab employeeId={employeeId}
                          employeeDependents={employeeDependents}
                          setEmployeeDependents={setEmployeeDependents} />
                      </TabPanel>

                      <TabPanel>
                        <EmergencyTab employeeId={employeeId}
                          employeeEmergencyContacts={employeeEmergencyContacts}
                          setEmployeeEmergencyContacts={setEmployeeEmergencyContacts} />
                      </TabPanel>

                      <TabPanel>
                        <FamilyTab employeeId={employeeId}
                          employeeFamilyData={employeeFamilyData}
                          setEmployeeFamilyData={setEmployeeFamilyData} />
                      </TabPanel>

                      <TabPanel>
                        <BenefitsTab viewedData={user} />
                      </TabPanel>

                      <TabPanel>
                        <RequirementsTab
                          viewedData={employeeData}
                        />
                      </TabPanel>

                      <TabPanel>
                        <GenerateQRIdTab viewedData={user} />
                      </TabPanel>
                    </div>
                  </Tabs>
                  {!loading && showUpdate &&
                    <div className="lowerpart">
                      <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
                        <button className="submit"
                          onClick={(event) => handleUpdate(event)}> UPDATE
                        </button>
                      </div>
                    </div>
                  }
                </div>
                <div className="tab-footer">
                  <div className="buttons row" style={{ justifyContent: "space-between" }}>
                    <button id={setButtonId("previous-button")}
                      className="previous row"
                      onClick={() => setSelectedTab(Previous(selectedTab))}><NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
                    </button>
                    <button id={setButtonId("next-button")}
                      className="next row"
                      onClick={() => setSelectedTab(Next(selectedTab))}> NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      <LoadingSpinner loading={loading} />

    </div>
  )
}

export default EmployeeInformation